import { parsePhoneNumberFromString } from "libphonenumber-js";
import { getRestaurantSettings } from "./currency";

export const sanitizePhoneNumber = (phone = "") => {
    return phone.replace(/[^\d+]/g, "");
};

export const COUNTRY_PHONE_CODES = {
    Afghanistan: "AF",
    Albania: "AL",
    Algeria: "DZ",
    Argentina: "AR",
    Armenia: "AM",
    Australia: "AU",
    Austria: "AT",
    Bangladesh: "BD",
    Belgium: "BE",
    Brazil: "BR",
    Bulgaria: "BG",
    Cambodia: "KH",
    Canada: "CA",
    China: "CN",
    Colombia: "CO",
    Croatia: "HR",
    CzechRepublic: "CZ",
    Denmark: "DK",
    Egypt: "EG",
    Finland: "FI",
    France: "FR",
    Germany: "DE",
    Greece: "GR",
    HongKong: "HK",
    Hungary: "HU",
    Iceland: "IS",
    India: "IN",
    Indonesia: "ID",
    Iran: "IR",
    Iraq: "IQ",
    Ireland: "IE",
    Israel: "IL",
    Italy: "IT",
    Japan: "JP",
    Kenya: "KE",
    Malaysia: "MY",
    Mexico: "MX",
    Nepal: "NP",
    Netherlands: "NL",
    NewZealand: "NZ",
    Nigeria: "NG",
    Norway: "NO",
    Pakistan: "PK",
    Philippines: "PH",
    Poland: "PL",
    Portugal: "PT",
    Qatar: "QA",
    Romania: "RO",
    Russia: "RU",
    SaudiArabia: "SA",
    Singapore: "SG",
    SouthAfrica: "ZA",
    SouthKorea: "KR",
    Spain: "ES",
    SriLanka: "LK",
    Sweden: "SE",
    Switzerland: "CH",
    Thailand: "TH",
    Turkey: "TR",
    UAE: "AE",
    UK: "GB",
    Ukraine: "UA",
    USA: "US",
    Vietnam: "VN",
};

export const getPhoneValidationRules = () => {
    const settings = getRestaurantSettings();

    return {
        placeholder: "Phone Number *",
        message: "Enter a valid phone number",
        countryCode:
            COUNTRY_PHONE_CODES[
            settings.country
            ] || null,
    };
};

export const validatePhoneNumber = (phone) => {
    const settings = getRestaurantSettings();

    const countryCode =
        COUNTRY_PHONE_CODES[settings.country];
    console.log("Validating phone number:", phone, "with country code:", countryCode);
    if (!countryCode) {
        return false;
    }

    try {
        const parsed = parsePhoneNumberFromString(
            phone,
            countryCode
        );
        console.log("phone:", phone);
        console.log("countryCode:", countryCode);
        console.log("parsed:", parsed?.number);
        console.log("isPossible:", parsed?.isPossible());
        console.log("isValid:", parsed?.isValid());

        if (!parsed) {
            return false;
        }

        // Reject all same digits
        const digits = phone.replace(/\D/g, "");

        if (
            /^(\d)\1+$/.test(digits) || // 0000000000, 1111111111
            digits === "1234567890" ||
            digits === "0123456789"
        ) {
            return false;
        }

        return (
            parsed.isPossible() &&
            digits.length >= 6
        );
    } catch {
        return false;
    }
};